import { FormProvider } from "react-hook-form";
import {
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../../../../../../components/ui/dialog";
import { BasicInput } from "../../../../../../components/BasicInput";
import { Button } from "../../../../../../components/ui/button";
import { cpfMask } from "../../../../../../../app/utils/cpfFormater";
import { phoneMask } from "@/app/utils/phoneFormater";
import useNewSimulationModal from "./useNewSimulationModal";
import RegistrationCard from "../components/registrationCard";
import { Spinner } from "@/view/components/ui/spinner";

interface NewSimulationModalProps {
  onBack: () => void;
}

export default function NewSimulationModal({
  onBack,
}: NewSimulationModalProps) {
  const {
    form,
    handleSubmit,
    isPending,
    isFetchingCustomer,
    list,
    searched,
    selectedCard,
    setSelectedCard,
    needsSelection,
  } = useNewSimulationModal();
  const {
    formState: { errors, isValid },
  } = form;

  return (
    <DialogContent className="flex max-h-[90vh] w-[95vw] max-w-[400px] flex-col overflow-y-auto md:max-w-[400px]">
      <DialogHeader className="border-b pb-8">
        <DialogTitle className="text-xl font-semibold text-black01">
          Vamos simular seu crédito
        </DialogTitle>
        <DialogDescription className="!mt-0 text-base text-black04">
          Preencha os dados abaixo para gerar as matrículas disponíveis para
          simulação
        </DialogDescription>
      </DialogHeader>

      <form onSubmit={handleSubmit}>
        <FormProvider {...form}>
          <div className="grid grid-cols-1 gap-4">
            <BasicInput
              name="cpf"
              maxLength={14}
              label="CPF"
              error={errors.cpf?.message}
              onInput={cpfMask}
            />
            {isFetchingCustomer && (
              <p className="-mt-3 text-sm text-black04">
                Buscando dados do cliente...
              </p>
            )}
            <BasicInput
              name="name"
              label="Nome completo"
              placeholder="Sarah Fernandes"
              maxLength={150}
              error={errors.name?.message}
            />
            <BasicInput
              name="email"
              label="E-mail"
              placeholder="exemplo@exemplo.com"
              error={errors.email?.message}
            />
            <BasicInput
              name="phone"
              label="Telefone"
              placeholder="(00) 00000-0000"
              maxLength={15}
              error={errors.phone?.message}
              onInput={phoneMask}
            />
            <BasicInput
              name="birthDate"
              type="date"
              label="Data de nascimento"
              placeholder="00/00/0000"
              maxLength={10}
              error={errors.birthDate?.message}
            />
          </div>

          {isPending ? (
            <div className="mt-8 flex justify-center">
              <Spinner size="small" />
            </div>
          ) : (
            <>
              {needsSelection ? (
                <div className="mt-8 flex flex-col gap-4">
                  <p className="text-sm font-medium text-black01">
                    Selecione a matrícula que deseja utilizar na simulação
                  </p>
                  <div className="scrollbar-thin scrollbar-thumb-gray01 scrollbar-track-transparent flex max-h-[350px] flex-col gap-4 overflow-y-auto">
                    {list?.map((item) => (
                      <RegistrationCard
                        key={item.RegistrationNumber}
                        cnpj={item.EmployerDocumentNumber.toString()}
                        onClick={() => setSelectedCard(item)}
                        selected={
                          selectedCard?.RegistrationNumber ===
                          item.RegistrationNumber
                        }
                        registrationNumber={item.RegistrationNumber}
                      />
                    ))}
                  </div>
                </div>
              ) : (
                searched &&
                list &&
                list.length === 0 && (
                  <div className="mt-8 flex flex-col items-center gap-1 text-center">
                    <p className="text-sm font-medium text-gray-800">
                      Nenhuma matrícula disponível
                    </p>
                    <p className="text-sm text-black04">
                      Não encontramos matrículas elegíveis para este CPF.
                    </p>
                  </div>
                )
              )}
            </>
          )}
          <div className="mt-8 flex items-center justify-center gap-2">
            <Button
              type="button"
              variant="outline"
              onClick={onBack}
              className="w-[160px] rounded-full text-primary"
            >
              Voltar
            </Button>
            <Button
              type="submit"
              disabled={
                !isValid || isPending || (needsSelection && !selectedCard)
              }
              className="w-[160px] rounded-full font-semibold text-white "
            >
              Prosseguir
            </Button>
          </div>
        </FormProvider>
      </form>
    </DialogContent>
  );
}
